import { render } from "./ConfirmItem.vue?vue&type=template&id=82a3daa8&scoped=true"
import script from "./ConfirmItem.vue?vue&type=script&lang=js"
export * from "./ConfirmItem.vue?vue&type=script&lang=js"

import "./ConfirmItem.vue?vue&type=style&index=0&id=82a3daa8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-82a3daa8"

export default script